// Sticky date header row for the Gantt grid.
import type { ReactElement } from "react";
import { isTodayUnit, unitLabel, type GanttScale } from "../lib/ganttScale";

export function GanttHeader({ scale }: { scale: GanttScale }) {
  const cells: ReactElement[] = [];
  for (let i = 0; i < scale.totalUnits; i += 1) {
    cells.push(
      <div
        key={i}
        className={`g-date-cell ${isTodayUnit(scale, i) ? "tc" : ""}`}
        style={{ width: scale.unitWidth }}
      >
        {unitLabel(scale, i)}
      </div>,
    );
  }
  return (
    <div className="g-hdr-row">
      <div className="g-label-col">Job</div>
      {cells}
    </div>
  );
}
